import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardRootPageDataQuery,
	StarterDashboardRootPageDataQueryVariables,
} from '../rootPageData.graphql';
import { StarterDashboardRootPageData } from '../rootPageData.graphql';

export async function getStarterRootPageData(
	fetch: UtilityContext['gql']['fetch'],
	{
		slug,
		completedSince,
		locale,
		countryCode,
		emailEnabled,
		includePetitionUpdatesInfo = true,
	}: {
		slug: string;
		completedSince: string;
		locale: string;
		countryCode: string;
		emailEnabled: boolean;
		includePetitionUpdatesInfo?: boolean;
	},
) {
	return fetch<StarterDashboardRootPageDataQuery, StarterDashboardRootPageDataQueryVariables>({
		query: StarterDashboardRootPageData,
		variables: {
			slug,
			completedSince,
			locale,
			countryCode,
			emailEnabled,
			includePetitionUpdatesInfo,
			skipShareVisuals: true, // Prevents on-demand generation for petitions outside the feature flag scope. TODO: Conditionally add this based on the FCM
		},
		rejectOnError: true,
	});
}
